
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ameegos/specialist",
      function () {
        return require("private-next-pages/ameegos/specialist.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ameegos/specialist"])
      });
    }
  